module.exports = __webpack_public_path__ + "static/wire-project-1-b5c359031373687b5cae63ff98296a7a.png";